import { useState } from 'react'
import {
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  Typography,
  TextField,
  Backdrop,
  makeStyles,
  CircularProgress
} from '@material-ui/core'
import { acceptIncidence } from '../../api/orderIncidences.service'
import LoadMultipleFiles from '../../components/Resources/LoadMultipleFiles'

const useStyles = makeStyles((theme) => ({
  backdrop: {
    zIndex: theme.zIndex.drawer + 1,
    color: '#fff'
  }
}))

const AcceptOrderIncidence = (params) => {
  const classes = useStyles
  const incidenceCode = params.incidenceCode
  const open = params.open
  const onSave = params.onSave
  const onCancel = params.onCancel

  const [stateForm, setStateForm] = useState({
    comment: ''
  })
  const [resources, setResources] = useState([])
  const [loading, setLoading] = useState(false)

  const handleInputChange = (event) => {
    const value = event.target.value
    const name = event.target.name

    setStateForm({
      ...stateForm,
      [name]: value
    })
  }

  const handleAcceptOrder = async () => {
    const params = {
      incidenceCode: incidenceCode,
      ...stateForm,
      attachments: resources
    }
    setLoading(true)
    await acceptIncidence(params)
      .then(() => {
        onSave()
        onCancel()
      })
      .finally(() => {
        setLoading(false)
      })
  }

  return (
    <div>
      <Dialog open={open}>
        <DialogContent>
          <Typography>{`Respuesta a la incidencia ${incidenceCode}`}</Typography>
          <TextField
            type="text"
            label="Comentario"
            placeholder="¿Tiene algún comentario? "
            name="comment"
            fullWidth
            variant="outlined"
            className="mt-3"
            multiline
            rows={3}
            value={stateForm.comment}
            disabled={loading}
            onChange={handleInputChange}
          />
          <LoadMultipleFiles canDelete={true} resources={resources} setResources={setResources} />
        </DialogContent>
        <DialogActions>
          <Button disabled={loading} onClick={handleAcceptOrder} autoFocus color="secondary">
            Aceptar
          </Button>
          <Button disabled={loading} onClick={onCancel}>
            Cancelar
          </Button>
        </DialogActions>
        <Backdrop className={classes.backdrop} open={loading} onClick={onCancel}>
          <CircularProgress color="inherit" />
        </Backdrop>
      </Dialog>
    </div>
  )
}

export default AcceptOrderIncidence
